__turbopack_context__.v({
  "btn_container": "Offers-module-scss-module__1qwHXq__btn_container",
  "button": "Offers-module-scss-module__1qwHXq__button",
  "offers": "Offers-module-scss-module__1qwHXq__offers",
  "offers__subtitle": "Offers-module-scss-module__1qwHXq__offers__subtitle",
  "offers__title": "Offers-module-scss-module__1qwHXq__offers__title",
  "offers_wrapper": "Offers-module-scss-module__1qwHXq__offers_wrapper",
});
